export default function GalleryBlock({ data }) {
  const images = (data && data.images) || [];
  if (!images.length) return null;
  return (
    <section className="py-10 md:py-14">
      <div className="max-w-6xl mx-auto px-6 md:px-8">
        <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
          {images.map((img, i) => {
            const src = typeof img === "string" ? img : img.url;
            const alt = typeof img === "string" ? "" : img.alt || "";
            const caption = typeof img === "string" ? "" : img.caption || "";
            if (!src) return null;
            return (
              <figure key={i} className="overflow-hidden rounded-xl border" style={{ borderColor: "var(--wp-border)" }}>
                <img src={src} alt={alt} className="w-full h-56 md:h-64 object-cover" />
                {caption && (
                  <figcaption className="text-xs px-3 py-2" style={{ color: "var(--wp-text-muted)" }}>
                    {caption}
                  </figcaption>
                )}
              </figure>
            );
          })}
        </div>
      </div>
    </section>
  );
}
